import { Col, Layout } from "antd";
import styled from "styled-components";

const { Header, Sider } = Layout;

export const WrapperLayout = styled(Layout)`
  min-height: 100vh;
  width: 100vw;
`;

export const ContentLayout = styled(Layout)`
  flex-direction: row;
  width: 100vw;
  min-height: 100vh;
  margin-top: 64px;
  /* padding: 80px 0 0 0; */
`;

export const WrapperSider = styled(Sider)`
  position: fixed !important;
  left: 0;
  top: 0;
  bottom: 0;
  overflow-y: auto;
  overflow-x: hidden;
  z-index: 101;
  height: 100vh;
  background: #ffffff !important;
  border-right: 1px solid #e8edf2;
  box-shadow: 2px 0 12px rgba(15, 23, 42, 0.04);
  
  & > span {
    display: none;
  }

  .ant-menu {
    border-right: none;
    background: transparent;
    padding: 8px 10px;
  }

  .ant-menu-item {
    margin: 2px 0;
    border-radius: 10px;
    height: 44px;
    line-height: 44px;
    padding: 0 16px !important;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    
    &:hover {
      background: #f8fafc;
    }

    &.ant-menu-item-selected {
      background: #fff4f0 !important;
      color: #E95735;
      font-weight: 600;

      &::after {
        display: none;
      }
    }
  }

  .ant-menu-submenu {
    .ant-menu-submenu-title {
      margin: 2px 0;
      border-radius: 10px;
      height: 44px;
      line-height: 44px;
      padding: 0 16px !important;
      transition: all 0.2s ease;
      display: flex;
      align-items: center;

      &:hover {
        background: #f8fafc;
      }
    }

    &.ant-menu-submenu-open,
    &.ant-menu-submenu-selected {
      .ant-menu-submenu-title {
        background: #f8fafc;
        color: #E95735;
        font-weight: 600;
      }
    }
  }

  .ant-menu-sub {
    background: transparent !important;
    
    .ant-menu-item {
      padding-left: 44px !important;
      height: 40px;
      line-height: 40px;
    }
  }

  .ant-menu-item,
  .ant-menu-submenu-title {
    font-size: 14px;
    color: #475569;
    font-weight: 500;
    
    .anticon, span[role="img"] {
      color: #94a3b8;
      margin-right: 12px !important;
      display: inline-flex;
      align-items: center;
      min-width: 18px;
    }

    a {
      color: inherit;
      text-decoration: none;
      display: flex;
      align-items: center;
      gap: 12px;
    }
  }

  .ant-menu-item-selected {
    .anticon, span[role="img"] {
      color: #E95735;
    }
  }
  
  .ant-menu-item-icon {
    margin-right: 12px !important;
  }

  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: #e2e8f0;
    border-radius: 3px;

    &:hover {
      background: #cbd5e1;
    }
  }
`;

//NavBar

export const WrapperHeader = styled(Header)`
  display: flex;
  flex-direction: row;
  text-align: left;
  font-size: 1rem;
  font-weight: 400;
  line-height: 64px !important;
  align-items: center;
  box-shadow: 0 1px 0 rgba(15, 23, 42, 0.06);
  z-index: 100;
  box-sizing: border-box;
  flex: 0 0 auto;
  color: #1e293b;
  background-color: #ffffff;
  padding: 0px 24px;
  height: 64px;
  position: fixed !important;
  top: 0px;
  left: 260px;
  right: 0px;
  border-bottom: 1px solid #e8edf2;
  transition: left 0.2s ease;
  backdrop-filter: blur(8px);
  background: rgba(255, 255, 255, 0.95);
`;

export const WrapperActionsRight = styled(Col)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

//LoginLayout
